import apiEndpoints from "../config/apiEndpoints";
import axiosInstance from "../api/axiosInstance";
import { vereist, spoor } from './verzoek';

// Elke dienst hieronder zegt wat hij nodig heeft, zegt wat hij ophaalt, en doet dat. Gaat er
// iets mis, dan gooit hij: de aanroeper weet als enige wat de gast op dat moment hoort te zien.
// Het naar Sentry sturen gebeurt in de onderschepper van axios, op een plek. (WI5)

export const getFeedback = async (key, lang, type) => {
    vereist('getFeedback', { key, lang, type });

    spoor("Fetching feedback", { key, lang, type });

    return axiosInstance.get(apiEndpoints.GET_FEEDBACK(key, lang, type));
};

export const createEnquete = async (data) => {
    vereist('createEnquete', { data });

    spoor("Creating enquete (feedback submission)", {});

    return axiosInstance.post(apiEndpoints.CREATE_FEEDBACK, data);
};

